import { css } from 'styled-components';
import { TokenName } from '@mews/design-tokens';
import { getToken } from '@optimus-web/common';
import { TypographyOptions, TypographyProps } from './types';

export const getTypographyOptions = (props: TypographyOptions) => css`
    ${props.align && `text-align: ${props.align};`}
    ${props.overflowWrap && `overflow-wrap: ${props.overflowWrap};`}
    ${props.wordBreak && `word-break: ${props.wordBreak};`}
    white-space: ${props.whiteSpace};
    ${props.textWrap && `text-wrap: ${props.textWrap};`}
`;

export interface Ellipticable {
    ellipsis?: boolean;
    maxLines?: number;
    whiteSpace?: TypographyOptions['whiteSpace'];
}

export const getEllipticableCss = (props: Ellipticable) =>
    props.ellipsis
        ? css`
              text-overflow: ellipsis;
              white-space: ${props.whiteSpace || 'nowrap'};
              overflow: hidden;

              ${props.maxLines &&
              css`
                  /* stylelint-disable-next-line value-no-vendor-prefix */
                  display: -webkit-box;
                  /* stylelint-disable-next-line property-no-vendor-prefix */
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: ${props.maxLines};
                  @supports (-webkit-line-clamp: 2) {
                      white-space: normal;
                  }
              `}
          `
        : '';

export const getTypographyColor = (props: Partial<TypographyProps>) => {
    const { variant = 'primary' } = props;
    let token: TokenName;

    switch (variant) {
        case 'primary':
            token = TokenName.textStaticPrimary;
            break;
        case 'secondary':
            token = TokenName.textStaticSecondary;
            break;
        case 'tertiary':
            token = TokenName.textStaticTertiary;
            break;
        case 'inverse':
            token = TokenName.textStaticInverse;
            break;
        case 'onColor':
            token = TokenName.textStaticOnColor;
            break;
        case 'danger':
            token = TokenName.textAlertDanger;
            break;
    }

    return getToken(token);
};
